<app-loading *ngIf="isLoading"></app-loading>
<div class="report-container">
  <ng-container *ngIf="!isInvalid && !isLoading; else errorblock">
    <iframe width="100%" height="100%" [src]="safeUrl" [title]="title"></iframe>
  </ng-container>

  <ng-template #errorblock>
    <div class="error-message">
      <p>Unable to display dashboard</p>
    </div>
  </ng-template>
</div>
